import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { SiteStyles } from '@portal-core/sites/models/site-styles.model';

@CollectionStateSelectors({
  stateType: SiteStylesState
})
@State<SiteStylesState>({
  name: SiteStylesState.source,
})
@Service({ autoProvided: false })
export class SiteStylesState extends CollectionStateBase {
  static override source: string = 'SiteStyles';
  getSource(): string {
    return SiteStylesState.source;
  }
}

@Service()
export class SiteStylesDataService extends CollectionDataServiceBase<SiteStyles> {
  protected readonly stateType = SiteStylesState;
}
